import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 16,
  medium: 10,
  small: 10,
  xSmall: 6
};
const BackToTopIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M19.8995 10.9497L14.9497 6L10 10.9497L10.7071 11.6569L14.4497 7.91421V24.9497H15.4497V7.91421L19.1924 11.6569L19.8995 10.9497Z",
        fill: "currentColor"
      }
    )
  );
};
BackToTopIcon.iconName = "BackToTopIcon";

export { BackToTopIcon };
